<template>
  <div class="cardsymbols">
    <div
      v-for="(card, idx) in cards"
      :key="card + idx"
      class="cardsymbols_block"
    >
      <div :class="`cardsymbols_value color-${colorDefault ? 'default-' : ''}${card[1]}`">
        {{ card[0] }}
      </div>
      <div :class="`cardsymbols_symbol color-${colorDefault ? 'default-' : ''}${card[1]}`">
        <component :is="card[1] + '_color'" />
      </div>
    </div>
  </div>
</template>

<script>
import { getCardsFromStr } from '@/helpers/cards'
import c_color from '@/assets/cards/club.svg'
import d_color from '@/assets/cards/diamond.svg'
import h_color from '@/assets/cards/heart.svg'
import s_color from '@/assets/cards/spade.svg'

export default {
  name: 'CardSymbols',
  components: {
    c_color,
    d_color,
    h_color,
    s_color,
  },
  props: {
    cardsIds: { default: '' },
    colorDefault: { type: Boolean, default: true },
  },
  data() {
    return {}
  },
  computed: {
    cards() {
      return getCardsFromStr(this.cardsIds)
    },
  },
}
</script>
<style lang="scss" scoped>
.cardsymbols {
  --size: 1.125rem;
  display: flex;
  &_block {
    display: flex;
    flex: 1;
  }
  &_value {
    font-size: var(--size);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    text-shadow: none;
    padding: 0 1px 0 0;
  }
  &_symbol {
    display: block;
    width: calc(var(--size) * 0.8);
    position: relative;
    left: -1px;
    fill: currentColor;
    svg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
</style>
